import { ToastContainer } from "react-toastify";
import MainRoutes from "./routes/main-routes";

function App() {
  return (
    <main>
      <MainRoutes />
      <ToastContainer
        position="bottom-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </main>
  );
}

export default App;
